import { Spinner } from '@welbe/web-design-system'
import React from 'react'

export const Loading = () => {
	const spinnerStyle = {
		display: 'flex',
		height: '70vh',
		margin: 'auto',
		justifyContent: 'center',
		alignItems: 'center',
	}
	return (
		<div style={spinnerStyle}>
			<Spinner size="30px" />
		</div>
	)
}
